import {useQuery} from 'react-query';
import {getStoryLimit} from '.';

function useGetStoryLimit() {
  const {data, isLoading} = useQuery({
    queryKey: ['story-limit'],
    queryFn: getStoryLimit,
  });
  return {data, isLoading};
}

export default useGetStoryLimit;
